import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  IAddEditExamCourseMasterParam,
  ICourse,
  ICourseMasterData,
  IExamCourseMasterRequest,
} from '../course-master-add-edit/interface/course-master.interface';
import { IDropdownListCode } from '../add-edit-exam-agency/interface/exam-agency.interface';
import { CourseManagementService } from './services/course.service';
import { ExamCourseMaster } from './enum/course-master.enum';
import { forkJoin, scheduled } from 'rxjs';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { options1 } from './config/tiny-config';
import { map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ICourseMaster } from '../interfaces/exam-agency.interface';
import { CourseMasterService } from '../course-master-add-edit/services/course-master.service';
import { maxValueValidator } from 'src/app/Validators/Validators';
import { StateService } from 'src/app/Services/stateServices/state.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CourseFeatureAvailabillityModalComponent } from './course-feature-availabillity-modal/course-feature-availabillity-modal.component';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { ExamInstanceSubjectsCAComponent } from './exam-instance-subjects/exam-instance-subjects/exam-instance-subjects.component';
import { TinyEditorModalComponent } from 'src/app/common/tiny-editor-modal/tiny-editor-modal.component';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { NotificationAddEditComponent } from 'src/app/Component/notification-management/notification-add-edit/notification-add-edit.component';


@Component({
  selector: 'app-course-add-edit',
  templateUrl: './course-edit-add.component.html',
  styleUrls: ['./course-edit-add.component,.css'],
})
export class CourseAddEditComponent {
  public env = environment;
  public courseMode: ExamCourseMaster;
  public locationCode: Array<IDropdownListCode> = [];
  public courseCategoryType: Array<IDropdownListCode> = [];
  public examLevelType: Array<IDropdownListCode> = [];
  public examDifficultLevelType: Array<IDropdownListCode> = [];
  public courseStatusType: Array<IDropdownListCode> = [];
  public answeringNumberingType: Array<IDropdownListCode> = [];
  public courseDeliveryType: Array<IDropdownListCode> = [];
  public yearsList: Array<IDropdownListCode> = [];
  public courseFeatureType: Array<IDropdownListCode> = [];
  public previewTextDisplayFLag: boolean = false;
  public courseList: Array<ICourse> = [];
  public selectedCourse = new FormControl();
  public tinyConfig = options1;
  public courseSubjectFlag: boolean = false;
  public cloneFilesLoading: boolean = false;
  today: string = this.fmt(new Date());
  @ViewChild(ExamInstanceSubjectsCAComponent)
  private examInstanceSubjectsCa!: ExamInstanceSubjectsCAComponent;

  public courseMasterName = '';
  public baseCourseName = '';
  public coursePlans: any = [];
  public initalFormValues: string = '';
  examAgencyRequestParam: IExamCourseMasterRequest = {
    loggedInUserId: '',
    examAgencyId: '',
    courseMasterId: '',
    courseId: '',
    examAgencyName: '',
  };

  months = [
  { label: "", value: '' },
  { label: "January", value: "January" },
  { label: "February", value: "February" },
  { label: "March", value: "March" },
  { label: "April", value: "April" },
  { label: "May", value: "May" },
  { label: "June", value: "June" },
  { label: "July", value: "July" },
  { label: "August", value: "August" },
  { label: "September", value: "September" },
  { label: "October", value: "October" },
  { label: "November", value: "November" },
  { label: "December", value: "December" }
];



  public readonly addCourseForm: FormGroup;
  constructor(
    private readonly courseManagementService: CourseManagementService,
    private readonly courseMasterService: CourseMasterService,
    private readonly route: ActivatedRoute,
    private readonly toaster: ToastrService,
    private readonly router: Router,
    private stateService: StateService,
    private modalService: NgbModal,
         private modalServiceLocal: ModalService,

  ) {
    this.addCourseForm = new FormGroup(
      {
        actualExamDate: new FormControl(),
        allBackNavigationInTest: new FormControl(),
        allowReviewAnswers: new FormControl(),
        allowSkippingQuestion: new FormControl(),
        answeringNumberLevel: new FormControl('', [Validators.required]),
        applicationDueDate: new FormControl(),
        courseAvailabilityEndDate: new FormControl('', [Validators.required]),
        courseAvailabilityStartDate: new FormControl('', [Validators.required]),
        courseCategoryType: new FormControl({ value: '', disabled: true }, [Validators.required]),
        courseDeliveryType: new FormControl('', [Validators.required]),
        courseIconImageDeletedInd: new FormControl('N'),
        courseIconImageFileLocationName: new FormControl(''),
        courseIconImageFileName: new FormControl(''),
        courseIconImageFileNameInServer: new FormControl(''),
        courseIconImageFileObjectId: new FormControl(),
        courseIconImageFileSourceModifiedDateTime: new FormControl(''),
        courseIconImageFileTypeCode: new FormControl(''),
        courseIconImageImageHeight: new FormControl(''),
        courseIconImageImageWidth: new FormControl(''),
        courseId: new FormControl(),
        courseImageDeletedInd: new FormControl('N'),
        courseImageFileLocationName: new FormControl(''),
        courseImageFileName: new FormControl(''),
        courseImageFileNameInServer: new FormControl(''),
        courseImageFileObjectId: new FormControl(),
        courseImageFileSourceModifiedDateTime: new FormControl(''),
        courseImageFileTypeCode: new FormControl(''),
        courseImageImageHeight: new FormControl(''),
        courseImageImageWidth: new FormControl(''),
        courseMaster: new FormControl(''),
        courseName: new FormControl({ value: '', disabled: true }, [Validators.required]),
        courseRating: new FormControl(),
        courseStatusType: new FormControl('', [Validators.required]),
        cutOfScore: new FormControl(),
        description: new FormControl(),
        examDifficultyLevel: new FormControl({ value: null, disabled: true }, [Validators.required]),
        examDurationInMinutes: new FormControl(),
        examLevel: new FormControl({ value: '', disabled: true }, [Validators.required]),
        examPassedCount: new FormControl(),
        examShortName: new FormControl({ value: '', disabled: true }, [Validators.required]),
        examYear: new FormControl('', [Validators.required]),
        examMonth: new FormControl(''),
        file1: new FormControl(),
        file2: new FormControl(),
        file3: new FormControl(),
        file4: new FormControl(),
        highestScorePercentage: new FormControl(),
        location: new FormControl('', [Validators.required]),
        notificationDate: new FormControl(),
        notificationUrl: new FormControl(),
        numberOfAnswerChoices: new FormControl(),
        numberOfOptionalQuestion: new FormControl({
          value: '',
          disabled: true,
        }),
        numberOfOptionalQuestionToBeAnswered: new FormControl(),
        fixedWrongAnswerScore: new FormControl(),
        fixedAnsweringTime: new FormControl(),
        fixedRightAnswerScore: new FormControl(),
        TimeToAnswerInSeconds: new FormControl({ value: '', disabled: true }),
        allowOptionalQuestion: new FormControl(),

        numberOfQuestion: new FormControl(),
        numberOfRegistrations: new FormControl(),
        numberOfTrailDays: new FormControl(),
        passRate: new FormControl(),
        previewFile1: new FormControl(),
        previewFile2: new FormControl(),
        previewFile3: new FormControl(),
        previewFile4: new FormControl(),
        randomQuestionOrder: new FormControl(),
        resultExpectedDate: new FormControl(),
        resultPublishedDate: new FormControl(),
        rightAnswerDefaultScore: new FormControl({ value: '', disabled: true }),
        scheduledExamDate: new FormControl(),
        subscriptionCount: new FormControl(),
        syllabusDeletedInd: new FormControl('N'),
        syllabusFileLocationName: new FormControl(''),
        syllabusFileName: new FormControl(''),
        syllabusFileNameInServer: new FormControl(''),
        syllabusFileObjectId: new FormControl(),
        syllabusFileSourceModifiedDateTime: new FormControl(''),
        syllabusFileTypeCode: new FormControl(''),
        syllabusImageHeight: new FormControl(''),
        syllabusImageWidth: new FormControl(''),
        examInstructionDeletedInd: new FormControl('N'),
        examInstructionArchivedInd: new FormControl('N'),

        examInstructionFileLocationName: new FormControl(''),
        examInstructionFileName: new FormControl(''),
        examInstructionFileNameInServer: new FormControl(''),
        examInstructionFileObjectId: new FormControl(),

        examInstructionFileSourceModifiedDateTime: new FormControl(''),
        examInstructionFileTypeCode: new FormControl(''),

        examInstructionImageHeight: new FormControl(''),
        examInstructionImageWidth: new FormControl(''),

        totalTestScore: new FormControl(),
        wrongAnswerDefaultScore: new FormControl({ value: '', disabled: true }),
        unattemptedAnswerDefaultScore: new FormControl(''),
        Course_Icon_Image_Archive_Ind: new FormControl(),
        Course_Image_Archive_Ind: new FormControl(),
        Course_Syllabus_Archive_Ind: new FormControl(),
      },
      {
        validators: [
          maxValueValidator(
            'numberOfOptionalQuestionToBeAnswered',
            'numberOfOptionalQuestion'
          ),
        ],
      }
    );

    this.retrieveLoggedInUserId();

    this.addCourseForm.get('courseMaster')?.disable();
  }

  ngOnInit() {
    this.checkExamModeEditOrAdd();
    this.fetchDropDownList();
    this.getCourses();
    this.initalFormValues = JSON.stringify(this.addCourseForm.getRawValue());
  }

    async CreateNotification(): Promise<boolean> {
      try {
        // Step 1: Ask for confirmation
        const result = await this.modalServiceLocal.open(
          'Confirmation',
          'Do you want to send notification to all the users about this Course?',
          'Yes',
          'No'
        );

        if (!result) {
          return false; // user cancelled
        }

        // Step 2: Open notification modal
        const modalRef = this.modalService.open(NotificationAddEditComponent, {
          centered: true,
          size: 'xl',
          windowClass: 'custom-modal-width-notification-course',
          backdropClass: 'custom-backdrop-notification'
        });

        // Pass data into modal
        modalRef.componentInstance.screenName = 'Course';
        modalRef.componentInstance.MaterialId =this.addCourseForm.getRawValue().courseId

        // Step 3: Wait for modal close result
        const notificationResult = await modalRef.result
          .then((res: any) => res)
          .catch(() => false);

        return !!notificationResult;
      } catch (error) {
        console.error('CreateNotification dismissed or failed:', error);
        return false;
      }
    }


  private checkExamModeEditOrAdd() {
    this.route.queryParams.subscribe((params) => {
      const { type, examAgencyId, courseMasterId, examAgencyName, courseId } =
        params as IAddEditExamCourseMasterParam;
      this.courseMode = type as ExamCourseMaster;

      this.examAgencyRequestParam.examAgencyId = examAgencyId;
      this.examAgencyRequestParam.courseMasterId = courseMasterId;
      this.examAgencyRequestParam.examAgencyName = examAgencyName;
      this.examAgencyRequestParam.courseId = courseId;
      if (type === ExamCourseMaster.EDIT || type === ExamCourseMaster.VIEW) {
        this.selectedCourse.disable();
      } else {
        this.getCourserMaster();
      }
    });
  }

  // YYYY-MM-DD for <input type="date">
private fmt(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

  get truncatedDescription(): string {
  const raw = this.addCourseForm.get('description')?.value || '';
  const tmp = document.createElement('div');
  tmp.innerHTML = raw;                     // parse HTML
  const text = tmp.textContent || tmp.innerText || '';

  const maxLength = 130;                   // set your limit
  return text.length > maxLength
    ? text.substring(0, maxLength) + '…'
    : text;

  }
async openDescritionEditor(){
    const modalRef = this.modalService.open(
      TinyEditorModalComponent,
      { size: 'xl', backdrop: 'static', centered: true }
    );
  const current = this.addCourseForm.get('description')?.value || '';
  modalRef.componentInstance.description = current;

  try {
    const updated: string = await modalRef.result; // resolves on .close()
    this.addCourseForm.patchValue({ description: updated });
    this.addCourseForm.get('description')?.markAsDirty();
    this.addCourseForm.get('description')?.markAsTouched();
  } catch {
    // dismissed (Cancel / ESC / backdrop) — do nothing
  }
}
// End date must be strictly greater than start date
get minEndDate(): string {
  const start = this.addCourseForm.get('courseAvailabilityStartDate')?.value;
  if (!start) return this.today;               // fallback until start chosen
  const d = new Date(start);
  d.setDate(d.getDate() + 1);                  // strictly greater than start
  return this.fmt(d);
}

// Optional: if user changes start to a later date, clear invalid end
onStartDateChange(): void {
  const endCtrl = this.addCourseForm.get('courseAvailabilityEndDate');
  if (!endCtrl?.value) return;
  // Compare as dates to be safe
  const pickedEnd = new Date(endCtrl.value);
  const minEnd = new Date(this.minEndDate);
  if (pickedEnd < minEnd) {
    endCtrl.setValue(null); // or '' if you prefer
  }
}


  showCourseAvailableFeatures() {
    const ref = this.modalService.open(CourseFeatureAvailabillityModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    ref.componentInstance.courseId = +(this.examAgencyRequestParam?.courseId ?? 0);
  }

  ClearClone() {
    this.addCourseForm.reset(this.initalFormValues);

    this.selectedCourse.setValue(null);

    // redirect
    this.router.navigateByUrl(
      `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${this.examAgencyRequestParam.courseMasterId}&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&type=Add`
    );
  }


  closeSubject(){
    this.examInstanceSubjectsCa.onClose()
    // this.courseSubjectFlag = false
  }

  onCloseSubject(event:any){
    this.courseSubjectFlag = false
  }

  getCourserMaster() {
    this.courseMasterService
      .getCourseMasterById<Array<ICourseMasterData>>(
        this.examAgencyRequestParam.loggedInUserId,
        this.examAgencyRequestParam.examAgencyId,
        this.examAgencyRequestParam.courseMasterId
      )
      .subscribe((data) => {
        this.patchDataInForm(data[0] || {});
      });
  }

  private patchDataInForm(courseMaster: ICourseMaster) {
    this.addCourseForm.patchValue({
      courseName: courseMaster?.Course_Name,
      courseMaster: courseMaster?.Course_Name,
      examShortName: courseMaster?.Exam_Short_Name,
      courseCategoryType: courseMaster?.Course_Category_Type_Code,
      examLevel: courseMaster?.Exam_Level_Type_Code,
      examDifficultyLevel: courseMaster?.Exam_Difficulty_Level_Type_Code,
      fixedRightAnswerScore: this.addCourseForm.get('rightAnswerDefaultScore')
        ?.value
        ? true
        : false,
    });
    this.initalFormValues = JSON.stringify(this.addCourseForm.getRawValue());
  }

  private fetchDropDownList(isClone?: boolean) {
    forkJoin([
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'LOCATION'
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'COURSE_CATEGORY_TYPE'
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'EXAM_LEVEL_TYPE'
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'EXAM_DIFFICULTY_LEVEL_TYPE'
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'COURSE_STATUS_TYPE'
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'ANSWER_NUMBERING_TYPE'
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'COURSE_DELIVERY_TYPE'
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>('YEAR'),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'COURSE_FEATURE_TYPE'
      ),
    ]).subscribe((elem) => {
      const [
        location,
        courseCategoryType,
        examLevelType,
        examDifficultLevelType,
        courseStatusType,
        answeringNumberingType,
        courseDeliveryType,
        yearsList,
        courseFeatureType,
      ] = elem as unknown as Array<Array<IDropdownListCode>>;
      this.locationCode = location;
      this.courseCategoryType = courseCategoryType;
      this.examLevelType = examLevelType;
      this.examDifficultLevelType = examDifficultLevelType;
      this.courseStatusType = courseStatusType;
      this.answeringNumberingType = answeringNumberingType;
      this.courseDeliveryType = courseDeliveryType;
      this.yearsList = yearsList;
      this.courseFeatureType = courseFeatureType;

      this.courseManagementService
        .getCourses<Array<ICourse>>(
          this.examAgencyRequestParam.loggedInUserId,
          '',
          this.examAgencyRequestParam.courseId as string,
          'ADMIN',
          null
        )
        .pipe(
          map((elem: Array<ICourse>) => {
            return elem.find(
              (accu) =>
                accu.Course_Id ===
                +(this.examAgencyRequestParam.courseId as unknown as number)
            ) as ICourse;
          }),
          switchMap((course: ICourse) => {
            return this.courseManagementService
              .getCourseMaster<Array<ICourseMaster>>(
                this.examAgencyRequestParam.loggedInUserId,
                +this.examAgencyRequestParam.examAgencyId,
                this.examAgencyRequestParam.courseMasterId
              )
              .pipe(
                map((courseMaster: Array<ICourseMaster>) => ({
                  courseMaster: courseMaster[0] || {},
                  course: course,
                }))
              );
          })
        )
        .subscribe(
          (courseMasterAndCourse: {
            courseMaster: ICourseMaster;
            course: ICourse;
          }) => {
            const { courseMaster, course } = courseMasterAndCourse;

            // Add mode is opened without a course id, so there is no course to read
            // from yet and the form keeps the values the course master patched in.
            if (!course) {
              if (isClone) {
                this.toaster.error('Could not load the course to clone.', 'Error');
              }
              return;
            }

            this.setCourseToForm(
              course as unknown as ICourse,
              courseMaster,
              isClone
            );

            this.getCoursePlans();
          }
        );
    });
  }

  public getCourses() {
    this.courseManagementService
      .getCourses<Array<ICourse>>(
        this.examAgencyRequestParam.loggedInUserId,
        this.examAgencyRequestParam.courseMasterId,
        null,
        'ADMIN',
        null
      )
      .subscribe((courses) => {
        this.courseList = courses;
      });
  }
  retrieveLoggedInUserId() {
    const loggedInUserId = UserAuthDetails.getUserLoggedInId();

    if (!loggedInUserId)
      return this.toaster.error('Please Provide Logged in User Id', 'Error');

    this.examAgencyRequestParam.loggedInUserId = loggedInUserId;
    return null;
  }

  preventEnteringString(
    event: KeyboardEvent,
    maxLen: number,
    allowNegative: boolean = false
  ) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement?.value || '';
    // Allow the negative sign only if the `allowNegative` flag is true
    if (event.key === '-' && allowNegative) {
      // Prevent multiple negative signs
      if (currentValue.includes('-') || currentValue.length > 0) {
        event.preventDefault();
        return false;
      }
      return true; // Allow the first negative sign
    }
    if (Number.isNaN(+event.key)) {
      return false;
    }

    if (((event.target as any)?.value || '').length > maxLen - 1) {
      return false;
    }

    return true;
  }
  preventEnteringE(event: KeyboardEvent, maxLen: number) {
    if (event.key === 'e' || event.key === '+' || event.key === '-') {
      return false;
    }

    if (((event.target as any)?.value || '').length > maxLen - 1) {
      return false;
    }

    return true;
  }

  // preventEnteringStringInDecimal

// e.g. constructor(private toastr: ToastrService) {}

imageHandle(event: Event, controlName: string, previewControlName?: string) {
  const input = event.target as HTMLInputElement | null;
  const file = input?.files?.[0];
  if (!input || !file) return;

  // If preview control exists => image; otherwise => pdf
  const expectImage = !!previewControlName;
  const expectPdf = !previewControlName;

  const name = (file.name || '').toLowerCase();
  const ext = name.slice(name.lastIndexOf('.'));
  const mime = file.type;

  const isJpegByMime = mime === 'image/jpeg';
  const isJpegByExt = ext === '.jpg' || ext === '.jpeg' || ext === '.png';
  const isPdfByMime = mime === 'application/pdf';
  const isPdfByExt = ext === '.pdf';

  // Validation
  if (expectImage && !(isJpegByMime || isJpegByExt)) {
    this.toaster.error('Only JPG,JPEG Or PNG images are allowed.','', { timeOut: 3000 });
    this.addCourseForm.get(controlName)?.reset();
    if (previewControlName) this.addCourseForm.get(previewControlName)?.reset();
    input.value = '';
    return;
  }

  if (expectPdf && !(isPdfByMime || isPdfByExt)) {
    this.toaster.error('Only PDF files are allowed.', '', { timeOut: 3000 });
    this.addCourseForm.get(controlName)?.reset();
    input.value = '';
    return;
  }

  // Set the file
  this.addCourseForm.get(controlName)?.setValue(file);

  // If image, generate preview
  if (previewControlName) {
    const reader = new FileReader();
    reader.onload = () => {
      this.addCourseForm.get(previewControlName)?.setValue(String(reader.result || ''));
    };
    reader.readAsDataURL(file);
  }

  // Allow re-selecting the same file
  input.value = '';
}



  clearUploadImage(type: string, previewFile: string) {
    this.addCourseForm.get(type)?.setValue(null);

    if (!previewFile) return;
    this.addCourseForm.get(previewFile)?.setValue(null);
  }

  clear() {
    const currentValues = this.addCourseForm.getRawValue();
    const isPristine = JSON.stringify(currentValues) === this.initalFormValues;
    if (isPristine) {
      this.addCourseForm.markAsPristine();
    } else {
    }
    if (this.addCourseForm.dirty) {
      const flag = window.confirm('Do you want to save the changes');

      if (flag) {
        this.formSubmit(false, true);
      } else {
        this.router.navigateByUrl(
          `/Exam/ExamAgencies/CourseMaster/ViewEdit?type=Edit&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&courseMasterId=${this.examAgencyRequestParam.courseMasterId}`
        );
      }
    } else {
      // this.addEditExamCourseMaster.reset();
      this.router.navigateByUrl(
        `/Exam/ExamAgencies/CourseMaster/ViewEdit?type=Edit&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&courseMasterId=${this.examAgencyRequestParam.courseMasterId}`
      );
    }
  }

  getCourseById() {
    this.router.navigateByUrl(
      `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${
        this.examAgencyRequestParam.courseMasterId
      }&examAgencyId=${
        this.examAgencyRequestParam.examAgencyId
      }&type=Add&courseId=${+this.selectedCourse.value}`,
  { skipLocationChange: true }
    );

    this.examAgencyRequestParam.courseId = this.selectedCourse.value;

    this.courseManagementService
      .getCourses<Array<ICourse>>(
        this.examAgencyRequestParam.loggedInUserId,
        this.examAgencyRequestParam.courseMasterId,
        this.selectedCourse.value,
        'ADMIN',
        null
      )
      .pipe(
        map((elem: Array<ICourse>) => {
          return elem.find(
            (accu) => accu.Course_Id === +this.selectedCourse.value
          );
        })
      )
      .subscribe((course) => {
        this.fetchDropDownList(true);
      });
  }

  formSubmit(del?: boolean, handleCancel?: boolean) {

      if (this.cloneFilesLoading) {
        this.toaster.info('Please wait, course files are still being copied.');
        return;
      }

      this.addCourseForm.markAllAsTouched();

      if (this.addCourseForm.invalid) {
        this.toaster.error('Please fill required fields.');
        return;
      }

      // For ADD mode, course images are required
      if (this.courseMode === ExamCourseMaster.ADD) {
        if (!this.addCourseForm.getRawValue().file1) {
          this.toaster.error('Course Image is required');
          return;
        }
        if (!this.addCourseForm.getRawValue().file2) {
          this.toaster.error('Course Image Icon is required');
          return;
        }
      }

      // For EDIT mode, validate if images are marked as deleted
      if(this.addCourseForm.getRawValue().courseImageDeletedInd ==='Y'&&!this.addCourseForm.getRawValue().file1 && !del){
        this.toaster.error('Course Image is required');
        return;
      }
      if(this.addCourseForm.getRawValue().courseIconImageDeletedInd ==='Y'&&!this.addCourseForm.getRawValue().file2 && !del){
        this.toaster.error('Course Image Icon is required');
        return;
      }


      this.courseManagementService
        .createOrUpdateCourse(this.createFormData(this.selectedCourse.value ? true : false))
        .subscribe((elem:any) => {
          if(elem.status ===400 && elem.Message.includes('Violation of UNIQUE KEY constraint')){
          this.toaster.error(`Course for this year and month already exists.`, '', {
                  timeOut: ConstantVars.ToastErrorTimeout,
                });
            return
          }

          this.addCourseForm
            .get('courseId')
            ?.setValue(
              (elem as unknown as { NewCourseId: string })
                ?.NewCourseId || this.examAgencyRequestParam?.courseId
            );
            this.CreateNotification()
                this.selectedCourse.setValue(null);
          this.courseManagementService
            .getCourses<Array<ICourse>>(
              this.examAgencyRequestParam.loggedInUserId,
              this.examAgencyRequestParam.courseMasterId,
              null,
              'ADMIN',
              null
            )
            .pipe(
              map((elem: Array<ICourse>) => {
                return elem.find(
                  (accu) =>
                    accu.Course_Id === +this.addCourseForm.getRawValue().courseId
                );
              })
            )
            .subscribe((course) => {
              console.log(course);
              if (del) {
                this.toaster.success(`Image Deleted Successfully.`, '', {
                  timeOut: 500,
                });
              } else {
                this.toaster.success(
                  `${
                    this.courseMode === 'Add' ? ' Saved ' : ' Saved '
                  } Successfully.`, 'Success',
                  {
                    timeOut: 500,
                  }
                );
              }

              if (handleCancel) {
                this.router.navigateByUrl(
                  `/Exam/ExamAgencies/CourseMaster/ViewEdit?type=Edit&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&courseMasterId=${this.examAgencyRequestParam.courseMasterId}`
                );
                return;
              }

              // this.setCourseToForm(course as unknown as ICourse);
              this.router.navigateByUrl(
                `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${this.examAgencyRequestParam.courseMasterId}&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&type=Edit&courseId=${course?.Course_Id}`
              );

              this.fetchDropDownList();
            });
        },(error)=>{
          console.log(error);

        });

  }

  cloneForm(isClone?: boolean) {
    this.courseManagementService
      .cloneCourse(this.createFormData(true))
      .subscribe((elem) => {
        const newCourseId = (elem as unknown as { NewCourseMasterID: string })
          ?.NewCourseMasterID;
        this.addCourseForm.get('courseId')?.setValue(newCourseId);

        this.courseManagementService
          .getCourses<Array<ICourse>>(
            this.examAgencyRequestParam.loggedInUserId,
            this.examAgencyRequestParam.courseMasterId,
            null,
            'ADMIN',
            null
          )
          .pipe(
            map((elem: Array<ICourse>) => {
              return elem.find(
                (accu) => accu.Course_Id === +(newCourseId as string)
              );
            })
          )
          .subscribe((course) => {
            console.log(course);
            if(this.courseMode === 'Edit'){
            this.selectedCourse.disable();
            }

            this.toaster.success(`Form Cloned Successfully.`, '', {
              timeOut: 500,
            });
            this.examAgencyRequestParam.courseId = newCourseId;
            // this.setCourseToForm(course as unknown as ICourse);
            this.router.navigateByUrl(
              `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${this.examAgencyRequestParam.courseMasterId}&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&type=Edit&courseId=${course?.Course_Id}`
            );

            this.fetchDropDownList();

            this.selectedCourse.reset();
          });
      });
  }

  private generateCourseDisplayName(courseName: string, examYear: string, examMonth: string): string {
    // Remove any existing (year) or (year : month) or (year - month) from the end
    const cleanedName = (courseName || '').replace(/\s*\(\d{4}(?:\s*[:\-]\s*\w+)?\)\s*$/, '').trim();
    if (examMonth && examMonth.trim()) {
      return `${cleanedName} (${examYear} : ${examMonth})`;
    } else {
      return `${cleanedName} (${examYear})`;
    }
  }

  setCourseToForm(
    course: ICourse,
    courseMaster: ICourseMaster,
    isClone?: boolean
  ) {

    this.courseMasterName = courseMaster.Course_Name;
    this.addCourseForm.patchValue({
      courseMaster: courseMaster.Course_Name,
      courseName: this.generateCourseDisplayName(course?.Course_Name, String(course?.Exam_Year), course?.Exam_Month),
      courseId: course.Course_Id,
      examShortName: course.Exam_Short_Name,
      examYear: course.Exam_Year,
      examMonth: course.Exam_Month,

      TimeToAnswerInSeconds: course.Time_To_Answer_In_Seconds,
      courseCategoryType: course.Course_Category_Type_Code,
      courseDeliveryType: course.Course_Delivery_Type_Code,
      courseAvailabilityStartDate: this.parseDate(
        course.Course_Availability_Start_Date
      ),
      courseAvailabilityEndDate: this.parseDate(
        course.Course_Availability_End_Date
      ),
      numberOfTrailDays: course.Trial_Number_Of_Days,

      courseImageFileObjectId: course.Course_Image_File_Object_Id,
      courseImageFileName: course.Course_Image_File_Name,
      courseImageFileNameInServer: course.Course_Image_File_Name_In_Server,
      courseImageFileSourceModifiedDateTime:
        course.Course_Image_File_Source_Modified_Datetime,
      courseImageFileTypeCode: course.Course_Image_File_Type_Code,
      courseImageFileLocationName: course.Course_Image_File_Location_Name,
      courseImageImageHeight: course.Course_Image_Image_Height,
      courseImageImageWidth: course.Course_Image_Image_Width,
      courseImageDeletedInd: course.Course_Image_Deleted_Ind?course.Course_Image_Deleted_Ind.toUpperCase():'N',
      file1: null,
      previewFile1: null,

      courseIconImageFileObjectId: course.Course_Logo_Image_File_Object_Id,
      courseIconImageFileName: course.Course_Logo_Image_File_Name,
      courseIconImageFileNameInServer:
        course.Course_Logo_Image_File_Name_In_Server,
      courseIconImageFileSourceModifiedDateTime:
        course.Course_Logo_Image_File_Source_Modified_Datetime,
      courseIconImageFileTypeCode: course.Course_Logo_Image_File_Type_Code,
      courseIconImageFileLocationName:
        course.Course_Logo_Image_File_Location_Name,
      courseIconImageImageHeight: course.Course_Logo_Image_Image_Height,
      courseIconImageImageWidth: course.Course_Logo_Image_Image_Width,
      courseIconImageDeletedInd:
      course?.Course_Logo_Image_Deleted_Ind
    ? course.Course_Logo_Image_Deleted_Ind.toUpperCase()
    : 'N',
      file2: null,
      previewFile2: null,

      syllabusFileObjectId: course.Course_Syllabus_File_Object_Id,
      syllabusFileName: course.Course_Syllabus_File_Name,
      syllabusFileNameInServer: course.Course_Syllabus_File_Name_In_Server,
      syllabusFileSourceModifiedDateTime:
        course.Course_Syllabus_File_Source_Modified_Datetime,
      syllabusFileTypeCode: course.Course_Syllabus_File_Type_Code,
      syllabusFileLocationName: course.Course_Syllabus_File_Location_Name,
      syllabusImageHeight: course.Course_Syllabus_Image_Height,
      syllabusImageWidth: course.Course_Syllabus_Image_Width,
      syllabusDeletedInd: course.Course_Syllabus_Deleted_Ind,
      file3: null,
      previewFile3: null,
      examInstructionFileObjectId:
  course.Exam_Instruction_File_Object_Id,

  examInstructionFileName:
    course.Exam_Instruction_File_Name,

  examInstructionFileNameInServer:
    course.Exam_Instruction_File_Name_In_Server,

  examInstructionFileSourceModifiedDateTime:
    course.Exam_Instruction_File_Source_Modified_Datetime,

  examInstructionFileTypeCode:
    course.Exam_Instruction_File_Type_Code,

  examInstructionFileLocationName:
    course.Exam_Instruction_File_Location_Name,

  examInstructionImageHeight:
    course.Exam_Instruction_Image_Height,

  examInstructionImageWidth:
    course.Exam_Instruction_Image_Width,

  examInstructionDeletedInd:
    course.Exam_Instruction_Deleted_Ind,

  examInstructionArchivedInd:
    course.Exam_Instruction_Archive_Ind,
          file4: null,
        previewFile4: null,


      notificationUrl: course.Notification_Url,

      courseStatusType: course.Course_Status_Type_Code,
      location: course.Location_ID,
      subscriptionCount: course.Course_Subscription_Count,
      courseRating: course.Course_Rating,
      notificationDate: this.parseDate(course.Notification_Date),
      examLevel: course.Exam_Level_Type_Code,
      examDifficultyLevel: course.Exam_Difficulty_Level_Type_Code,
      applicationDueDate: this.parseDate(course.Application_Due_Date),
      scheduledExamDate: this.parseDate(course.Scheduled_Exam_Date),
      actualExamDate: this.parseDate(course.Actual_Exam_Date),
      resultExpectedDate: this.parseDate(course.Result_Expected_Date),
      resultPublishedDate: this.parseDate(course.Result_Published_Date),
      examDurationInMinutes: course.Exam_Duration,
      allBackNavigationInTest:
        course.Allow_Back_Navigation_In_Test_Ind === 'Y' ||
        course.Allow_Back_Navigation_In_Test_Ind === 'y'
          ? true
          : false,
      allowSkippingQuestion:
        course.Allow_Skip_Ind === 'Y' || course.Allow_Skip_Ind === 'y'
          ? true
          : false,
      allowReviewAnswers:
        course.Allow_Review_Ind === 'Y' || course.Allow_Review_Ind === 'y'
          ? true
          : false,
      randomQuestionOrder:
        course.Random_Question_Order_Ind === 'Y' ||
        course.Random_Question_Order_Ind === 'y'
          ? true
          : false,
      totalTestScore: course.Total_Test_Score,
      cutOfScore: course.Exam_Cut_Off_Score,
      passRate: course.Exam_Pass_Rate,
      highestScorePercentage: course.Highest_Score,
      numberOfRegistrations: course.Number_Of_Registration,
      examPassedCount: course.Exam_Passed_Count,
      numberOfAnswerChoices: course.Number_Of_Answer_Choices,
      answeringNumberLevel: course.Answer_Numbering_Type_Code,
      rightAnswerDefaultScore: course.Right_Answer_Default_Score,
      wrongAnswerDefaultScore: course.Wrong_Answer_Penalty_Default_Score,
      unattemptedAnswerDefaultScore: course.Unattempted_Answer_Penalty_Default_Score ,
      numberOfQuestion: course.Number_Of_Question,
      numberOfOptionalQuestion: course.Total_Number_Of_Optional_Questions,
      numberOfOptionalQuestionToBeAnswered:
        course.Number_Of_Optional_Questions_To_Be_Answered,
      description: course.Course_Description,
      fixedRightAnswerScore: course.Right_Answer_Default_Score ? true : false,
      fixedWrongAnswerScore: course.Wrong_Answer_Penalty_Default_Score
        ? true
        : false,
      fixedAnsweringTime: course.Time_To_Answer_In_Seconds ? true : false,
      allowOptionalQuestion: course.Total_Number_Of_Optional_Questions
        ? true
        : false,
      Course_Syllabus_Archive_Ind: course.Course_Syllabus_Archive_Ind,
      Course_Image_Archive_Ind: course.Course_Image_Archive_Ind,
      Course_Icon_Image_Archive_Ind: course.Course_Icon_Image_Archive_Ind,
    });
    if (this.addCourseForm.get('rightAnswerDefaultScore')?.value) {
      this.addCourseForm.get('rightAnswerDefaultScore')?.enable();
    }
    if (this.addCourseForm.get('wrongAnswerDefaultScore')?.value) {
      this.addCourseForm.get('wrongAnswerDefaultScore')?.enable();
    }
    if (this.addCourseForm.get('TimeToAnswerInSeconds')?.value) {
      this.addCourseForm.get('TimeToAnswerInSeconds')?.enable();
    }
    if (this.addCourseForm.get('numberOfOptionalQuestion')?.value) {
      this.addCourseForm.get('numberOfOptionalQuestion')?.enable();
    }
    this.initalFormValues = JSON.stringify(this.addCourseForm.getRawValue());

    if (isClone) {
      this.stageClonedFiles();
    }
  }

  private readonly cloneFileFields = [
    {
      label: 'Course Image',
      fileControl: 'file1',
      previewControl: 'previewFile1',
      objectIdControl: 'courseImageFileObjectId',
      fileNameControl: 'courseImageFileName',
      nameInServerControl: 'courseImageFileNameInServer',
      locationControl: 'courseImageFileLocationName',
      modifiedDateControl: 'courseImageFileSourceModifiedDateTime',
      deletedIndControl: 'courseImageDeletedInd',
      archiveIndControl: 'Course_Image_Archive_Ind',
    },
    {
      label: 'Course Image Icon',
      fileControl: 'file2',
      previewControl: 'previewFile2',
      objectIdControl: 'courseIconImageFileObjectId',
      fileNameControl: 'courseIconImageFileName',
      nameInServerControl: 'courseIconImageFileNameInServer',
      locationControl: 'courseIconImageFileLocationName',
      modifiedDateControl: 'courseIconImageFileSourceModifiedDateTime',
      deletedIndControl: 'courseIconImageDeletedInd',
      archiveIndControl: 'Course_Icon_Image_Archive_Ind',
    },
    {
      label: 'Syllabus Document',
      fileControl: 'file3',
      previewControl: '',
      objectIdControl: 'syllabusFileObjectId',
      fileNameControl: 'syllabusFileName',
      nameInServerControl: 'syllabusFileNameInServer',
      locationControl: 'syllabusFileLocationName',
      modifiedDateControl: 'syllabusFileSourceModifiedDateTime',
      deletedIndControl: 'syllabusDeletedInd',
      archiveIndControl: 'Course_Syllabus_Archive_Ind',
    },
    {
      label: 'Exam Instructions',
      fileControl: 'file4',
      previewControl: '',
      objectIdControl: 'examInstructionFileObjectId',
      fileNameControl: 'examInstructionFileName',
      nameInServerControl: 'examInstructionFileNameInServer',
      locationControl: 'examInstructionFileLocationName',
      modifiedDateControl: 'examInstructionFileSourceModifiedDateTime',
      deletedIndControl: 'examInstructionDeletedInd',
      archiveIndControl: 'examInstructionArchivedInd',
    },
  ];

  // On clone the new course must own its files, so the source files are downloaded,
  // kept in the form as file1..file4 and every server side identifier is blanked out
  // (object id empty, deleted / archived 'N') so the API inserts brand new files.
  private async stageClonedFiles() {
    const raw = this.addCourseForm.getRawValue();
    const failed: Array<string> = [];

    this.cloneFilesLoading = true;

    for (const field of this.cloneFileFields) {
      const locationName = raw[field.locationControl];
      const fileNameInServer = raw[field.nameInServerControl];
      const isDeleted =
        String(raw[field.deletedIndControl] || '').toUpperCase() === 'Y';

      const patch: { [key: string]: unknown } = {
        [field.fileControl]: null,
        [field.objectIdControl]: null,
        [field.nameInServerControl]: '',
        [field.locationControl]: '',
        [field.modifiedDateControl]: '',
        [field.deletedIndControl]: 'N',
        [field.archiveIndControl]: 'N',
      };

      if (field.previewControl) {
        patch[field.previewControl] = null;
      }

      if (!locationName || !fileNameInServer || isDeleted) {
        this.addCourseForm.patchValue(patch);
        continue;
      }

      const file = await this.downloadExistingFile(
        locationName,
        fileNameInServer,
        raw[field.fileNameControl]
      );

      if (!file) {
        failed.push(field.label);
        this.addCourseForm.patchValue(patch);
        continue;
      }

      patch[field.fileControl] = file;

      if (field.previewControl) {
        patch[field.previewControl] = await this.readFileAsDataUrl(file);
      }

      this.addCourseForm.patchValue(patch);
    }

    this.initalFormValues = JSON.stringify(this.addCourseForm.getRawValue());

    this.cloneFilesLoading = false;

    if (failed.length) {
      this.toaster.warning(
        `Could not copy ${failed.join(', ')}. Please upload again.`,
        '',
        { timeOut: ConstantVars.ToastErrorTimeout }
      );
    }
  }

  private async downloadExistingFile(
    locationName: string,
    fileNameInServer: string,
    fileName: string
  ): Promise<File | null> {
    // Read the file from our own origin (proxy.conf.js forwards it while serving
    // locally): the API host serves these static paths without CORS headers, so a
    // direct cross origin read would be blocked by the browser.
    const filePath = `${locationName}/${fileNameInServer}`;

    const url = filePath.toLowerCase().startsWith('http')
      ? filePath
      : '/' + filePath.split('/').filter(Boolean).join('/');

    try {
      const response = await fetch(url);

      if (!response.ok) return null;

      const blob = await response.blob();

      return new File([blob], fileName || fileNameInServer, {
        type: blob.type || 'application/octet-stream',
      });
    } catch {
      return null;
    }
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => resolve('');
      reader.readAsDataURL(file);
    });
  }

  formatToTwoDecimals(event: FocusEvent, fieldName: string): void {
    const inputElement = event.target as HTMLInputElement;
    const value = parseFloat(inputElement.value);

    // Check if the value is a valid number
    if (!isNaN(value)) {
      const formattedValue = value.toFixed(2);
      inputElement.value = formattedValue;

      // Update the form control with the formatted value
      this.addCourseForm.get(fieldName)?.setValue(formattedValue);
    }
  }

  preventEnteringDecimalString(event: KeyboardEvent, maxLen: number) {
    try {
      if (
        Number.isFinite(+(event as any).target.value) &&
        event?.key?.length <= maxLen
      ) {
        return true;
      }

      const newVal = (event as any).target?.value?.split('');

      newVal.pop();

      (event as any).target.value = newVal.join('');

      return false;
    } catch (err) {
      const newVal = (event as any).target?.value?.split('');

      newVal.pop();

      (event as any).target.value = newVal.join('');
      return false;
    }
  }

  parseDate(dateStr: string) {
    if (!dateStr) return null;
    const date = new Date(dateStr);

    if (Number.isNaN(date.getTime())) return null;

    const m =
      date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const d = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;

    const _d = `${date.getFullYear()}-${m}-${d}`;

    return _d;
  }

  fixedRightAnswerScoreChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.checked;
    if (value) {
      this.addCourseForm.get('rightAnswerDefaultScore')?.setValue(null);
      this.addCourseForm.get('rightAnswerDefaultScore')?.enable();
    } else {
      this.addCourseForm.get('rightAnswerDefaultScore')?.disable();
      this.addCourseForm.get('rightAnswerDefaultScore')?.setValue(null);
    }
  }
  fixedWrongtAnswerScoreChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.checked;
    if (value) {
      this.addCourseForm.get('wrongAnswerDefaultScore')?.setValue(null);
      this.addCourseForm.get('wrongAnswerDefaultScore')?.enable();
    } else {
      this.addCourseForm.get('wrongAnswerDefaultScore')?.disable();
      this.addCourseForm.get('wrongAnswerDefaultScore')?.setValue(null);
    }
  }
  fixedAnsweringTimeChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.checked;
    if (value) {
      this.addCourseForm.get('TimeToAnswerInSeconds')?.setValue(null);
      this.addCourseForm.get('TimeToAnswerInSeconds')?.enable();
    } else {
      this.addCourseForm.get('TimeToAnswerInSeconds')?.disable();
      this.addCourseForm.get('TimeToAnswerInSeconds')?.setValue(null);
    }
  }
  allowOptionalQuestionChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.checked;
    if (value) {
      this.addCourseForm.get('numberOfOptionalQuestion')?.setValue(null);
      this.addCourseForm.get('numberOfOptionalQuestion')?.enable();
    } else {
      this.addCourseForm.get('numberOfOptionalQuestion')?.disable();
      this.addCourseForm.get('numberOfOptionalQuestion')?.setValue(null);
    }
  }

  createFormData(isClone?: boolean) {
    const formdata = new FormData();
    const raw = this.addCourseForm.getRawValue();
    if (raw.file1) {
      formdata.append(
        'file1',
        raw.file1,
        raw.file1?.name
      );
    }
    if (raw.file2) {
      formdata.append(
        'file2',
        raw.file2,
        raw.file2?.name
      );
    }
    if (raw.file3) {
      formdata.append(
        'file3',
        raw.file3,
        raw.file3.name
      );
    }
    if (raw.file4) {
      formdata.append(
        'file4',
        raw.file4,
        raw.file4.name
      );
    }

    formdata.append('LoggedInUser', this.examAgencyRequestParam.loggedInUserId);
    formdata.append(
      'CourseMasterId',
      this.examAgencyRequestParam.courseMasterId || ''
    );
    formdata.append('ExamAgencyIdForFileManagement', this.examAgencyRequestParam.examAgencyId);
    formdata.append('CourseName', raw.courseName || '');
    formdata.append(
      'ExamShortName',
      raw.examShortName || ''
    );
    formdata.append('CloneInd',this.selectedCourse.value ? 'Y' : 'N' );
    formdata.append('ExamYear', raw.examYear );
    formdata.append('ExamMonth', raw.examMonth);
    formdata.append(
      'CourseID',
      isClone ? '' : raw.courseId || ''
    );
    formdata.append(
      'CourseCategoryTypeCode',
      raw.courseCategoryType || ''
    );
    formdata.append(
      'CourseDeliveryTypeCode',
      raw.courseDeliveryType || ''
    );
    formdata.append(
      'CourseStatusTypeCode',
      raw.courseStatusType || ''
    );
    formdata.append(
      'CourseSubscriptionCount',
      raw.subscriptionCount || ''
    );
    formdata.append(
      'CourseAvailabilityStartDate',
      raw.courseAvailabilityStartDate || ''
    );
    formdata.append(
      'CourseAvailabilityEndDate',
      raw.courseAvailabilityEndDate || ''
    );
    formdata.append(
      'CourseImageArchiveInd',
      raw.Course_Image_Archive_Ind || ''
    );
    formdata.append(
      'CourseIconImageArchiveInd',
      raw.Course_Icon_Image_Archive_Ind || ''
    );
    formdata.append(
      'CourseSyllabusArchiveInd',
      raw.Course_Syllabus_Archive_Ind || ''
    );
    formdata.append(
      'TrialNumberOfDays',
      raw.numberOfTrailDays || ''
    );
    formdata.append(
      'CourseRating',
      raw.courseRating || ''
    );
    formdata.append(
      'CourseDescription',
      raw.description || ''
    );
    formdata.append(
      'ExamDifficultyLevelTypeCode',
      raw.examDifficultyLevel || ''
    );
    formdata.append(
      'ExamLevelTypeCode',
      raw.examLevel || ''
    );
    formdata.append(
      'AnswerNumberingTypeCode',
      raw.answeringNumberLevel || ''
    );
    formdata.append(
      'NotificationDate',
      raw.notificationDate || ''
    );
    formdata.append(
      'NotificationUrl',
      raw.notificationUrl || ''
    );
    formdata.append(
      'ApplicationDueDate',
      raw.applicationDueDate || ''
    );
    formdata.append(
      'ScheduledExamDate',
      raw.scheduledExamDate || ''
    );
    formdata.append(
      'ActualExamDate',
      raw.actualExamDate || ''
    );
    formdata.append(
      'ResultExpectedDate',
      raw.resultExpectedDate || ''
    );
    formdata.append(
      'ResultPublishedDate',
      raw.resultPublishedDate || ''
    );
    formdata.append(
      'AllowBackNavigationInTestInd',
      raw.allBackNavigationInTest ? 'Y' : 'N'
    );
    formdata.append(
      'AllowQuestionSkipInd',
      raw.allowSkippingQuestion ? 'Y' : 'N'
    );
    formdata.append(
      'AllowQuestionReviewInd',
      raw.allowReviewAnswers ? 'Y' : 'N'
    );
    formdata.append(
      'RandomQuestionOrderInd',
      raw.randomQuestionOrder ? 'Y' : 'N'
    );
    formdata.append(
      'TotalTestScore',
      raw.totalTestScore || ''
    );
    formdata.append(
      'ExamCutOffScore',
      raw.cutOfScore || ''
    );
    formdata.append('ExamPassRate', raw.passRate || '');
    formdata.append(
      'HighestScore',
      raw.highestScorePercentage || ''
    );
    formdata.append(
      'ExamPassedCount',
      raw.examPassedCount || ''
    );
    formdata.append(
      'NumberOfRegistration',
      raw.numberOfRegistrations || ''
    );
    formdata.append(
      'ExamDuration',
      raw.examDurationInMinutes || ''
    );
    formdata.append(
      'TimeToAnswerInSeconds',
      raw.TimeToAnswerInSeconds || ''
    );
    formdata.append(
      'RightAnswerDefaultScore',
      raw.rightAnswerDefaultScore || ''
    );
    formdata.append(
      'WrongAnswerPenaltyDefaultScore',
      raw.wrongAnswerDefaultScore || ''
    );
    formdata.append(
      'UnattemptedAnswerPenaltyDefaultScore',
      raw.unattemptedAnswerDefaultScore || ''
    );
    formdata.append(
      'NumberOfQuestion',
      raw.numberOfQuestion || ''
    );
    formdata.append(
      'NumberOfAnswerChoices',
      raw.numberOfAnswerChoices || ''
    );
    formdata.append(
      'TotalNumberOfOptionalQuestions',
      raw.numberOfOptionalQuestion || ''
    );
    formdata.append(
      'NumberOfOptionalQuestionsToBeAnswered',
      raw.numberOfOptionalQuestionToBeAnswered || ''
    );
    formdata.append('LocationID', raw.location || '');
    formdata.append(
      'CourseImageFileObjectId',
      raw.courseImageFileObjectId || ''
    );
    formdata.append(
      'CourseImageFileName',
      raw.courseImageFileName || ''
    );
    formdata.append(
      'CourseImageFileNameInServer',
      raw.courseImageFileNameInServer || ''
    );
    formdata.append(
      'CourseImageFileSourceModifiedDateTime',
      raw.courseImageFileSourceModifiedDateTime || ''
    );
    formdata.append(
      'CourseImageFileTypeCode',
      raw.courseImageFileTypeCode || ''
    );
    formdata.append(
      'CourseImageFileLocationName',
      raw.courseImageFileLocationName || ''
    );
    formdata.append(
      'CourseImageImageHeight',
      raw.courseImageImageHeight || ''
    );
    formdata.append(
      'CourseImageImageWidth',
      raw.courseImageImageWidth || ''
    );
    formdata.append(
      'CourseImageDeletedInd',
      raw.courseImageDeletedInd
    );
    formdata.append(
      'CourseIconImageFileObjectId',
      raw.courseIconImageFileObjectId || ''
    );
    formdata.append(
      'CourseIconImageFileName',
      raw.courseIconImageFileName || ''
    );
    formdata.append(
      'CourseIconImageFileNameInServer',
      raw.courseIconImageFileNameInServer || ''
    );
    formdata.append(
      'CourseIconImageFileSourceModifiedDateTime',
      raw.courseIconImageFileSourceModifiedDateTime || ''
    );
    formdata.append(
      'CourseIconImageFileTypeCode',
      raw.courseIconImageFileTypeCode || ''
    );
    formdata.append(
      'CourseIconImageFileLocationName',
      raw.courseIconImageFileLocationName || ''
    );
    formdata.append(
      'CourseIconImageImageHeight',
      raw.courseIconImageImageHeight || ''
    );
    formdata.append(
      'CourseIconImageImageWidth',
      raw.courseIconImageImageWidth || ''
    );
    formdata.append(
      'CourseIconImagedeletedInd',
      raw.courseIconImageDeletedInd
    );
    formdata.append(
      'SyllabusFileObjectId',
      raw.syllabusFileObjectId || ''
    );
    formdata.append(
      'SyllabusFileName',
      raw.syllabusFileName || ''
    );
    formdata.append(
      'SyllabusFileNameInServer',
      raw.syllabusFileNameInServer || ''
    );
    formdata.append(
      'SyllabusFileSourceModifiedDateTime',
      raw.syllabusFileSourceModifiedDateTime || ''
    );
    formdata.append(
      'SyllabusFileTypeCode',
      raw.syllabusFileTypeCode || ''
    );
    formdata.append(
      'SyllabusFileLocationName',
      raw.syllabusFileLocationName || ''
    );
    formdata.append(
      'SyllabusImageHeight',
      raw.syllabusImageHeight || ''
    );

    formdata.append(
      'SyllabusImageWidth',
      raw.syllabusImageWidth || ''
    );
    formdata.append(
      'SyllabusdeletedInd',
      raw.syllabusDeletedInd ||''
    );

    formdata.append(
  'ExamInstructionFileObjectId',
  raw.examInstructionFileObjectId ?? ''
);

formdata.append(
  'ExamInstructionFileName',
  raw.examInstructionFileName || ''
);

formdata.append(
  'ExamInstructionFileNameInServer',
  raw.examInstructionFileNameInServer || ''
);

formdata.append(
  'ExamInstructionFileSourceModifiedDateTime',
  raw.examInstructionFileSourceModifiedDateTime || ''
);

formdata.append(
  'ExamInstructionFileTypeCode',
  raw.examInstructionFileTypeCode || ''
);

formdata.append(
  'ExamInstructionFileLocationName',
  raw.examInstructionFileLocationName || ''
);

formdata.append(
  'ExamInstructionImageHeight',
  raw.examInstructionImageHeight ?? ''
);

formdata.append(
  'ExamInstructionImageWidth',
  raw.examInstructionImageWidth ?? ''
);

formdata.append(
  'ExamInstructiondeletedInd',
  raw.examInstructionDeletedInd || ''
);

formdata.append(
  'ExamInstructionArchivedInd',
  raw.examInstructionArchivedInd || ''
);



    formdata.forEach((value, key) => {
      if (value instanceof File) {
        console.log(`${key}: File(name=${value.name}, size=${value.size}, type=${value.type})`);
      } else {
        console.log(`${key}: ${value}`);
      }
    });


    return formdata;
  }

  deleteImage(controlName: string,fieldName:string) {
    this.addCourseForm.get(controlName)?.setValue('Y');
    if(fieldName==='file1'){
    this.addCourseForm.get(fieldName)?.setValue(null);
    // this.addCourseForm.get('courseImageFileObjectId')?.setValue(null);
    // this.addCourseForm.get('courseImageFileLocationName')?.setValue(null);
    // this.addCourseForm.get('courseImageFileNameInServer')?.setValue(null);
    return
    }else if(fieldName==='file2'){
      this.addCourseForm.get(fieldName)?.setValue(null);
      // this.addCourseForm.get('courseIconImageFileObjectId')?.setValue(null);
      // this.addCourseForm.get('courseIconImageFileLocationName')?.setValue(null);
      // this.addCourseForm.get('courseIconImageFileNameInServer')?.setValue(null);
      return
    }else if(fieldName==='file3'){
      this.addCourseForm.get(fieldName)?.setValue(null);
      // this.addCourseForm.get('syllabusFileObjectId')?.setValue(null);
      // this.addCourseForm.get('syllabusFileLocationName')?.setValue(null);
      // this.addCourseForm.get('syllabusFileNameInServer')?.setValue(null);

    }else if(fieldName==='file4'){
      this.addCourseForm.get(fieldName)?.setValue(null);
      // this.addCourseForm.get('examInstructionFileObjectId')?.setValue(null);
      // this.addCourseForm.get('examInstructionFileLocationName')?.setValue(null);
      // this.addCourseForm.get('examInstructionFileNameInServer')?.setValue(null);
    }
    // this.formSubmit(true);
  }

  displayDialogOff() {
    this.previewTextDisplayFLag = false;
  }

  openPdf(url: string) {
    window.open(url, '', 'width=1000');
  }

  addCoursePlan() {
    this.courseManagementService.getFeaturesForCoursePlanAvailable({"CourseId":this.examAgencyRequestParam.courseId}).subscribe((res)=>{
      console.log(res)

      if(res && res.length<1){
        this.toaster.error('Please add Available Course Features before adding Course Plan.', 'Error');
        return
      }else{
        const param = `Exam/ExamAgencies/CourseMaster/Course/CoursePlan/ViewEdit?type=Add&examAgencyId=${
          this.examAgencyRequestParam.examAgencyId || ''
        }&examAgencyName=${
          this.examAgencyRequestParam.examAgencyName || ''
        }&courseId=${this.examAgencyRequestParam.courseId}&courseMasterId=${
          this.examAgencyRequestParam.courseMasterId || ''
        }&courseName=${this.addCourseForm.getRawValue().courseName || ''}`;
        this.router.navigateByUrl(param);
      }
    })

  }

  getCoursePlans() {
    if (!this.examAgencyRequestParam.courseId) return;

    this.courseManagementService
      .getCoursePlans(
        this.examAgencyRequestParam.loggedInUserId,
        +this.examAgencyRequestParam.courseId,
        null,
        'ADMIN',
        null,
        null
      )
      .subscribe((elem: any) => {
        this.coursePlans = elem.coursePlan.map((coursePlan: any) => {
          const cpfName = elem.coursePlanFeature.filter(
            (cpf: any) => cpf.Course_Plan_Id === coursePlan.Course_Plan_Id
          );
          return {
            ...coursePlan,
            coursePlanFeature: cpfName,

            courseFeatureTypeNames: this.courseFeatureType.map((cpfn: any) => {
              const flag = cpfName.find((cp: any) =>
                Object.values(cp).includes(cpfn.Code)
              );
              return {
                ...cpfn,
                isActive: !!flag,
                Feature_Value: flag ? flag.Feature_Value : 'No',
              };
            }),
          };
        });
        console.log(elem,"Response");
        console.log(this.coursePlans,"coursePlans");
        console.log(this.courseFeatureType,"courseFeatureType");

      });
  }

addCoursePlanFeatures(coursePlanId: number) {
  this.router.navigate(
    ['Exam/ExamAgencies/CourseMaster/Course/CoursePlan/ViewEdit'],
    {
      queryParams: {
        type: 'Edit',
        examAgencyId: this.examAgencyRequestParam.examAgencyId || '',
        examAgencyName: this.examAgencyRequestParam.examAgencyName || '',
        courseId: this.examAgencyRequestParam.courseId || '',
        coursePlanId: coursePlanId || '',
        courseMasterId: this.examAgencyRequestParam.courseMasterId || '',
        courseName: this.addCourseForm.getRawValue().courseName || ''
      },
      state: { returnUrl: this.router.url } // <<— key line
      // do NOT use replaceUrl:true here
    }
  );
}


  visibleInto() {
    document.querySelector('#viewCourse')?.scrollIntoView();
  }
}
